export default __webpack_public_path__ + "static/media/gf_logo.86bd9e6f.svg";